export default "__VITE_ASSET__Dv5UGz6r__"